<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      :titulo="$t ('Interfonías')"
      icono="mdi-phone-in-talk"
      tabla="disint"
      :campos="['id_disint', 'des', 'id_ins', 'id_apa', 'id_cam1', 'id_cam2-', 'id_cam3-']"
      :campos-filtrables="['id_ins']"
      busqueda-rapida
      :titulo-crud="$t ('dispositivo de interfonía')"
      permitir-anadir
      permitir-modificar
      permitir-eliminar
    />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
};
</script>

<style>
</style>